import trashIcon from "../assets/trashcan.svg";

const ClearMapSelectionModal = () => {
    console.log("ClearMapSelectionModal component rendered");

    const handleClearMapSelection = () => {
        window.parent.postMessage(
            {
                message: "clearMapSelection",
            },
            "*"
        );

        console.log("Clear map selection message sent.");
    };

    return (
        <div
            style={{
                display: "flex",
                alignItems: "flex-start",
                justifyContent: "center",
                width: "100%",
                minHeight: "320px",
                padding: "16px",
                backgroundColor: "#ffffff",
                boxSizing: "border-box",
            }}
        >
            <div
                style={{
                    width: "320px",
                    minHeight: "288px",
                    padding: "24px",
                    border: "1px solid #d9d9d9",
                    borderRadius: "6px",
                    backgroundColor: "#ffffff",
                    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
                    boxSizing: "border-box",
                }}
            >
                <p
                    style={{
                        marginTop: "32px",
                        fontSize: "14px",
                        fontWeight: 700,
                        color: "#4b3832",
                    }}
                >
                    The area that you selected on the map is small enough that
                    not all indicators can be calculated. For more information,
                    see the Help &amp; Feedback section. Please clear your
                    selection below and select a larger area.
                </p>

                <button
                    type="button"
                    style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        width: "100%",
                        height: "40px",
                        marginTop: "16px",
                        border: "1px solid #337ab7",
                        borderRadius: "6px",
                        backgroundColor: "#337ab7",
                        color: "#ffffff",
                        cursor: "pointer",
                    }}
                    onClick={handleClearMapSelection}
                >
                    <img
                        src={trashIcon}
                        style={{
                            width: "16px",
                            height: "16px",
                            marginRight: "8px",
                        }}
                        alt=""
                    />

                    <span
                        style={{
                            fontSize: "12px",
                            fontWeight: 700,
                        }}
                    >
                        Clear Map Selection
                    </span>
                </button>
            </div>
        </div>
    );
};

export default ClearMapSelectionModal;